<template>
  <div id="double_canvas">
    <div id="J_share_poster" class="share-container" ref="canvasRef" v-if="posterEnable && skuInfo">
      <div class="share-inner">
        <div class="share-logo">
          <img data-width="138" data-height="37" data-src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM4IiBoZWlnaHQ9IjM3IiB2aWV3Qm94PSIwIDAgMTM4IDM3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xMjQuNTc0IDMwLjUyM0gxMTIuODFjLTYuNjEzIDAtNy4yLTUuNDIyLTcuMi03LjA3OXMuNTg3LTcuMDc5IDcuMi03LjA3OWgxMS43NjRjNi42MTMgMCA3LjIwMiA1LjQyMiA3LjIwMiA3LjA4IDAgMS42NTYtLjU4OSA3LjA3OC03LjIwMiA3LjA3OG0wLTIwLjEyMUgxMTIuODFjLTEyLjIyNiAwLTEzLjMxMyA5Ljk5LTEzLjMxMyAxMy4wNDIgMCAzLjA1MiAxLjA4NyAxMy4wNDMgMTMuMzEzIDEzLjA0M2gxMS43NjRjMTIuMjI2IDAgMTMuMzEzLTkuOTkgMTMuMzEzLTEzLjA0MyAwLTMuMDUyLTEuMDg3LTEzLjA0Mi0xMy4zMTMtMTMuMDQybS0yNy40MzcuNjExaC0zLjgxM2MtMS42MzQgMC0xLjk3LjI4LTIuNiAxLjIxMy0uNjMuOTM1LTExLjUzNiAxNy41ODItMTEuNTM2IDE3LjU4Mi0uMzQ4LjUxMi0uNzE2LjcyLTEuMTc2LjcyLS40NTkgMC0uODI4LS4yMDgtMS4xNzYtLjcyIDAgMC0xMC45MDUtMTYuNjQ3LTExLjUzNi0xNy41ODItLjYzLS45MzQtLjk2Ni0xLjIxMy0yLjU5OS0xLjIxM2gtMy44MTNjLS44NzggMC0xLjI3OS42ODYtLjcyNyAxLjUyNGwxMy4wMjUgMTkuNzc1YzIuMDIyIDIuOTczIDMuNTA1IDQuMTc1IDYuODI2IDQuMTc1IDMuMzIyIDAgNC44MDUtMS4yMDIgNi44MjYtNC4xNzVsMTMuMDI2LTE5Ljc3NWMuNTUyLS44MzguMTUtMS41MjQtLjcyNy0xLjUyNG0tNTAuNjQyIDEuNjE2YzAtMS4xNTcuNDU5LTEuNjE1IDEuNjE1LTEuNjE1aDIuODgyYzEuMTU3IDAgMS42MTYuNDU4IDEuNjE2IDEuNjE1VjM0Ljg3YzAgMS4xNTctLjQ2IDEuNjE2LTEuNjE2IDEuNjE2SDQ4LjExYy0xLjE1NiAwLTEuNjE1LS40NTktMS42MTUtMS42MTZWMTIuNjN6bS0uMjYzLTYuODA4Yy0uOTQtLjkzOS0uOTQtMS42ODMgMC0yLjYyM2wyLjAwOC0yLjAwN2MuOTM5LS45MzkgMS42ODQtLjkzOSAyLjYyMyAwbDIuMDA4IDIuMDA3Yy45MzguOTQuOTM4IDEuNjg0IDAgMi42MjNsLTIuMDA4IDIuMDA3Yy0uOTQuOTQtMS42ODQuOTQtMi42MjMgMGwtMi4wMDgtMi4wMDd6bS02LjAxOCA1LjE5MmgtMy44MTNjLTEuNjMyIDAtMS45Ny4yOC0yLjU5OSAxLjIxMy0uNjMuOTM1LTExLjUzNiAxNy41ODItMTEuNTM2IDE3LjU4Mi0uMzQ4LjUxMi0uNzE3LjcyLTEuMTc2LjcyLS40NiAwLS44MjgtLjIwOC0xLjE3Ni0uNzIgMCAwLTEwLjkwNi0xNi42NDctMTEuNTM2LTE3LjU4Mi0uNjMtLjkzNC0uOTY2LTEuMjEzLTIuNi0xLjIxM0gxLjk2N2MtLjk4IDAtMS4yOC42ODYtLjcyNyAxLjUyNGwxMy4wMjUgMTkuNzc1YzIuMDIxIDIuOTczIDMuNTA1IDQuMTc1IDYuODI2IDQuMTc1IDMuMzIxIDAgNC44MDUtMS4yMDIgNi44MjYtNC4xNzVsMTMuMDI2LTE5Ljc3NWMuNTUxLS44MzguMjUzLTEuNTI0LS43MjgtMS41MjQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="/>
        </div>
        <div class="share-img">
          <img :data-width="commodityImgSize" :data-height="commodityImgSize" :data-src="mainSkuPic" />
        </div>
        <div class="share-detail">
          <p class="share-name">{{ skuInfo.commoditySkuBaseInfo.skuName }}</p>
          <p class="share-description">{{ skuInfo.commoditySkuBaseInfo.shortBrief }}</p>
          <div v-if="isGroup" class="share-group-panel">
            <span class="group-label">{{ actTag }}</span>
            <span class="share-price-label">¥</span>
            <span class="share-price-1">{{ skuInfo.commoditySkuDiscount.commodityDiscountPrice }}</span>
            <span class="sale-price">¥{{ skuInfo.commoditySkuBaseInfo.marketPrice }}</span>
          </div>
          <p class="share-price-panel" v-else>
            <span class="share-price-label">¥</span>
            <span class="share-price-1">{{ skuInfo.commoditySkuBaseInfo.salePrice }}</span>
          </p>
        </div>
        <div class="share-qrcode-panel">
          <div class="qrcode-des">
            <p class="line-1">长按二维码查看产品详情</p>
            <p class="line-2">分享来自vivo官方商城</p>
          </div>
          <!-- <img data-width="430" data-height="430" :data-src="qrcodeUrl" class="qrcode" /> -->
        </div>
      </div>
      <p class="share-quanyi" v-if="guaranteeList">
        <span>{{ guaranteeList }}</span>
      </p>
    </div>
    <div
      id="J_mini_poster"
      :class="{ top9: !isProxySale }"
      class="mini-container"
      v-if="posterEnable && skuInfo && isAndroidApp"
    >
      <div class="mini-img">
        <img :data-width="commodityImgSize" :data-height="commodityImgSize" :data-src="mainSkuPic" />
      </div>
      <p class="mini-quanyi" v-if="guaranteeShort">
        <span>{{ guaranteeShort }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import env from '@/utils/clientEnv'
export default {
  name: 'PosterPainter',
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo', 'skuShareInfoStore']),
    ...mapGetters('detailv3', ['posterEnable', 'skuId', 'isProxySale', 'isLottery', 'isGroup']),
    actTag(){
      const grouponNumber = this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.grouponNumber
      return this.isLottery ? '【抽奖团】' : this.isGroup && grouponNumber? `【${grouponNumber}人团】` : ''
    },
    isAndroidApp() {
      return env.isVivoApp
    },
    commodityImgSize(){
      const pic = this.skuInfo.imageInfos[0].bigPic
      const matchList = pic?.match(/_(\d{0,4})x/i)
      if(matchList && matchList.length > 1){
        return matchList[1] - 0
      }
      return 750
    },
    mainSkuPic(){
      return this.skuInfo.imageInfos[0].bigPic + '?t='+new Date().getTime()
    },
    // qrcodeUrl() {
    //   return this.skuShareInfoStore[this.skuId]?.qrcodeUrl
    // },
    guaranteeList() {
      const MAX_LEN = 21 // 容纳的字符上限
      let tips = (this.spuInfo.commodityServiceTips || []).flatMap(v => v.serviceName)
      if (!tips.length) return ''
      // 仅取前4个权益
      if (tips.length > 4) {
        tips = tips.splice(0, 4)
      }
      const originStr = tips.join('')
      if (originStr.length > MAX_LEN) {
        const lastStr = originStr.slice(MAX_LEN)
        let index = tips.findIndex(tip => {
          return !!lastStr.match(new RegExp(tip))
        })

        if (index < 0) {
          tips = tips.length > 1 ? tips.splice(0, tips.length - 1) : [tips[0]]
        } else {
          tips = tips[index] == lastStr || index <= 1 ? tips.splice(0, index) : tips.splice(0, index - 1)
        }
      }
      return tips.join(' · ')
    },
    guaranteeShort() {
      const MAX_LEN = 18 // 容纳的字符上限
      let tips = (this.spuInfo.commodityServiceTips || []).flatMap(v => v.serviceName)
      if (!tips.length) return ''
      // 仅取前4个权益
      if (tips.length > 3) {
        tips = tips.splice(0, 3)
      }
      const originStr = tips.join('')
      if (originStr.length > MAX_LEN) {
        const lastStr = originStr.slice(MAX_LEN)
        let index = tips.findIndex(tip => {
          return !!lastStr.match(new RegExp(tip))
        })

        if (index < 0) {
          tips = tips.length > 1 ? tips.splice(0, tips.length - 1) : [tips[0]]
        } else {
          tips = tips[index] == lastStr || index <= 1 ? tips.splice(0, index) : tips.splice(0, index - 1)
        }
      }
      return tips.join(' · ')
    }
  },
  mounted() {
    var style = document.createElement('style')
    style.type = 'text/css'
    style.dataset['canvasIgnore'] = 'false'
    let styleInner = `
#double_canvas {
  font-family: 'Microsoft Yahei', Arial;
  font-variant: normal;
  position: fixed;
  width: 8.4rem;
  height: 14rem;
  z-index: -999;
  top: -999px;
  left: -999px;
  background: #FFFFFF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
#double_canvas .share-container {
  font-family: 'Microsoft Yahei', Arial;
  font-variant: normal;
  position: relative;
  width: 8.4rem;
  z-index: -999;
  background: #FFFFFF;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
#double_canvas .share-container * {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
#double_canvas .share-container .share-inner{
  position: relative;
  width: 8.4rem;
  height: 12.75rem;
  background: #FFFFFF;
}
#double_canvas .share-container p{
  quotes: none;
}
#double_canvas .share-container img{
  max-width: 100%;
  vertical-align: bottom;
}

#double_canvas .share-logo {
  position: absolute;
  width: 2.08rem;
  height: 0.55rem;
  left: 3.16rem;
  top: 0.78rem;
  font-size:0;
}
#double_canvas .share-logo img{
  width: 2.08rem;
  height: 0.55rem;
}
#double_canvas .share-img {
  position: absolute;
  width: 6.06rem;
  height: 6.06rem;
  left: 1.17rem;
  top: 2.1rem;
}
#double_canvas .share-img img{
  width: 6.06rem;
  height: 6.06rem;
  object-fit: contain;
}
#double_canvas .share-detail {
  position: absolute;
  bottom: 2.92rem;
  width: 100%;
  text-align: center;
}
#double_canvas .share-name {
  width: 5.92rem;
  margin: 0 auto;
  color: #000000;
  font-size: 0.36rem;
  line-height: 0.42rem;
  font-family: 'Microsoft Yahei', Arial;
  -webkit-text-stroke: 0.2px;
}
#double_canvas .share-description {
  padding-top: 0.15rem;
  color: #333;
  font-size: 0.36rem;
  line-height: 0.36rem;
}
#double_canvas .share-group-panel {
  height: 0.39rem;
  font-size: 0;
  margin-top: 0.24rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
#double_canvas .group-label {
  position: relative;
  font-size: 0.3rem;
  line-height: 1;
  margin-top: 0.03rem;
  color:#000000;
}
#double_canvas .sale-price{
  font-size: 0.27rem;
  line-height: 0.36rem;
  margin-left: 0.12rem;
  margin-top: 0.03rem;
  color: #999999;
  text-decoration: line-through;
}
#double_canvas .share-price-panel {
  vertical-align: bottom;
  height: 0.36rem;
  font-size: 0;
  margin-top: 0.24rem;
  color: #000000;
}
#double_canvas .share-group-panel .share-price-label{
  line-height: 0.39rem;
}
#double_canvas .share-price-label {
  display: inline-block;
  font-size: 0.3rem;
  line-height: 0.3rem;
  margin-right: 0.04rem;
  font-family: 'Microsoft Yahei', Arial;
  -webkit-text-stroke: 0.1px;
}
#double_canvas .share-price-1 {
  display: inline-block;
  font-size: 0.36rem;
  line-height: 0.36rem;
  font-family: 'Microsoft Yahei', Arial;
  -webkit-text-stroke: 0.2px;
}
#double_canvas .share-quanyi {
  position: relative;
  background: #1B1A1A;
  text-align: center;
  height: 0.7rem;
  padding: 0.2rem 0;
  color: rgba(255, 255, 255, 0.44);
  white-space:nowrap;
  box-sizing: border-box;
}
#double_canvas .share-quanyi span{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%) scale(0.5);
    font-size: 0.6rem;
    line-height: 0.6rem;
    letter-spacing: 0.04rem;
    display: inline-block;
}
#double_canvas .share-qrcode-panel {
  position: absolute;
  bottom:  0;
  left: 0;
  width: 100%;
  height: 2.32rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
  background: #F5F5F5;
  padding: 0.21rem 0.55rem 0.39rem 0.65rem;
  box-sizing: border-box;
}
#double_canvas .share-qrcode-panel .qrcode {
  width: 1.72rem;
  height: 1.72rem;
}
#double_canvas .share-qrcode-panel .line-1 {
  padding-top: 0.54rem;
  color: rgba(153, 153, 153, 0.71);;
  font-size: 0.3rem;
  line-height: 0.3rem;
}
#double_canvas .share-qrcode-panel .line-2 {
  color: rgba(153, 153, 153, 0.71);;
  font-size: 0.3rem;
  line-height: 0.3rem;
  margin-top: 0.18rem;
}
.vivo-fontscale-1 #double_canvas .share-name{
  font-size: 0.45rem;
  line-height: 0.525rem;
}
.vivo-fontscale-2 #double_canvas .share-name{
  font-size: 0.4rem;
  line-height: 0.47rem;
}
.vivo-fontscale-4 #double_canvas .share-name{
  font-size: 0.32rem;
  line-height: 0.375rem;
}
.vivo-fontscale-5 #double_canvas .share-name{
    font-size: 0.288rem;
  line-height:  0.336rem;
}
.vivo-fontscale-1 #double_canvas .share-description ,
.vivo-fontscale-1 #double_canvas .share-price-1{
  font-size: 0.45rem;
  line-height: 0.45rem;
}
.vivo-fontscale-2 #double_canvas .share-description,
.vivo-fontscale-2 #double_canvas .share-price-1{
  font-size: 0.4rem;
  line-height: 0.4rem;
}
.vivo-fontscale-4 #double_canvas .share-description,
.vivo-fontscale-4 #double_canvas .share-price-1{
  font-size: 0.32rem;
  line-height: 0.32rem;
}
.vivo-fontscale-5 #double_canvas .share-description,
.vivo-fontscale-5 #double_canvas .share-price-1{
    font-size: 0.288rem;
  line-height:  0.288rem;
}
.vivo-fontscale-1 #double_canvas .share-quanyi span{
      font-size: 0.75rem;
  line-height: 0.75rem;
}
.vivo-fontscale-2 #double_canvas .share-quanyi span{
      font-size: 0.66rem;
  line-height: 0.66rem;
}
.vivo-fontscale-4 #double_canvas .share-quanyi span{
    font-size: 0.54rem;
  line-height:  0.54rem;
}
.vivo-fontscale-5 #double_canvas .share-quanyi span{
    font-size: 0.48rem;
  line-height:  0.48rem;
}

.vivo-fontscale-1 #double_canvas .share-group-panel{
  height: 0.49rem;
}
.vivo-fontscale-2 #double_canvas .share-group-panel{
  height: 0.43rem;
}
.vivo-fontscale-4 #double_canvas .share-group-panel{
  height: 0.35rem;
}
.vivo-fontscale-5 #double_canvas .share-group-panel{
  height: 0.31rem;
}
.vivo-fontscale-1 #double_canvas .group-label{
  font-size: 0.375rem;
  line-height: 0.375rem;
  margin-top: 0.04rem;
}
.vivo-fontscale-2 #double_canvas .group-label{
  font-size: 0.33rem;
  line-height: 0.33rem;
  margin-top: 0.04rem;
}
.vivo-fontscale-4 #double_canvas .group-label{
  font-size: 0.27rem;
  line-height: 0.27rem;
}
.vivo-fontscale-5 #double_canvas .group-label{
  font-size: 0.24rem;
  line-height: 0.24rem;
  margin-top: 0.02rem;
}

.vivo-fontscale-1 #double_canvas .share-group-panel .share-price-label{
  line-height: 0.49rem;
  margin-top: 0;
}
.vivo-fontscale-2 #double_canvas .share-group-panel .share-price-label{
  line-height: 0.43rem;
  margin-top: 0;
}
.vivo-fontscale-4 #double_canvas .share-group-panel .share-price-label{
  line-height: 0.35rem;
  margin-top: 0;
}
.vivo-fontscale-5 #double_canvas .share-group-panel .share-price-label{
  line-height: 0.31rem;
  margin-top: 0;
}
.vivo-fontscale-5 #double_canvas .share-group-panel .share-price-1{
  margin-top: -0.02rem;
}
.vivo-fontscale-1 #double_canvas .sale-price{
  font-size: 0.34rem;
  line-height: 0.45rem;
  margin-top: 0.04rem;
}
.vivo-fontscale-2 #double_canvas .sale-price{
  font-size: 0.3rem;
  line-height: 0.4rem;
  margin-top: 0.03rem;
}
.vivo-fontscale-4 #double_canvas .sale-price{
  font-size: 0.24rem;
  line-height: 0.32rem;
  margin-top: 0.03rem;
}
.vivo-fontscale-5 #double_canvas .sale-price{
  font-size: 0.22rem;
  line-height: 0.288rem;
  margin-top: 0.02rem;
}
.vivo-fontscale-1 #double_canvas .share-price-label,
.vivo-fontscale-1 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-1 #double_canvas .share-qrcode-panel .line-2{
      font-size: 0.375rem;
  line-height: 0.375rem;
}
.vivo-fontscale-2 #double_canvas .share-price-label,
.vivo-fontscale-2 #double_canvas .share-qrcode-panel .line-1,
.vivo-fontscale-2 #double_canvas .share-qrcode-panel .line-2{
      font-size: 0.33rem;
  line-height: 0.33rem;
}
.vivo-fontscale-4 #double_canvas .share-price-label,
.vivo-fontscale-4 #double_canvas .share-qrcode-panel .line-1, 
.vivo-fontscale-4 #double_canvas .share-qrcode-panel .line-2{
    font-size: 0.27rem;
  line-height:  0.27rem;
}
.vivo-fontscale-5 #double_canvas .share-price-label,
.vivo-fontscale-5 #double_canvas .share-qrcode-panel .line-1, 
.vivo-fontscale-5 #double_canvas .share-qrcode-panel .line-2{
    font-size: 0.24rem;
  line-height:  0.24rem;
}
.vivo-fontscale-1 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.03rem;
}
.vivo-fontscale-4 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.04rem;
}
.vivo-fontscale-5 #double_canvas .share-price-label{
  vertical-align: top;
  margin-top: 0.06rem;
}
`
    if (this.isAndroidApp) {
      styleInner += `
    #double_canvas .mini-container * {
      margin: 0;
      padding: 0;
      border: 0;
      font: inherit;
      font-size: 100%;
      vertical-align: baseline;
    }
    #double_canvas .mini-container p {
      quotes: none;
    }
    #double_canvas .mini-container img {
      max-width: 100%;
      vertical-align: bottom;
    }
    #double_canvas .mini-container {
      font-family: 'Microsoft Yahei', Arial;
      font-variant: normal;
      position: fixed;
      top: -99999;
      left: -99999;
      width: 6rem;
      height: 4.8rem;
      z-index: -999;
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
      background: transparent;
    }
    #double_canvas .mini-img {
      position: relative;
      width: 4.35rem;
      height: 4.35rem;
      margin: 0 auto;
      text-align: center;
    }
    #double_canvas .mini-container.top9  .mini-img{
      margin-top: -0.09rem;
    }
    #double_canvas .mini-img img{
      width: 4.35rem;
      height: 4.35rem;
      object-fit: contain;
    }
    #double_canvas .mini-quanyi {
      position:relative;
      text-align: center;
      height: 0.3rem;
      margin-top: 0.08rem;
      color: #999999;
      white-space:nowrap;
    }
    #double_canvas .mini-container.top9  .mini-quanyi{
       margin-top: 0.17rem;
    }
    #double_canvas .mini-quanyi span{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        font-size: 0.3rem;
        line-height: 0.3rem;
        display: inline-block;
        white-space:nowrap;
    }
    .vivo-fontscale-1 #double_canvas .mini-quanyi span{
        line-height: 0.375rem;
      font-size: 0.375rem;
    }
    .vivo-fontscale-2 #double_canvas .mini-quanyi span{
            line-height: 0.335rem;
      font-size: 0.335rem;
    }
    .vivo-fontscale-4 #double_canvas .mini-quanyi span{
        font-size: 0.27rem;
      line-height:  0.27rem;
    }
    .vivo-fontscale-5 #double_canvas .mini-quanyi span{
        font-size: 0.24rem;
      line-height:  0.24rem;
    }
    `
    }
    style.innerHTML = styleInner
    document.getElementsByTagName('head').item(0).appendChild(style)
  }
}
</script>
